module.exports = __webpack_public_path__ + "static/media/image_(1).3b56d81e.svg";